import { Badge, Box, Card } from '@palmetto/palmetto-components';

import { Applicant, ProgramType } from 'types';

import { AccountRequirementStatus } from '../../types/Milestone';
import { StatusIcon } from '../StatusIcon';

import { GetTermsLinkModal } from './GetTermsLinkModal';

interface TermsAndConditionProps {
  status: AccountRequirementStatus;
  programType: ProgramType;
  primaryApplicant?: Applicant;
}

export function TermsAndConditions({ status, programType, primaryApplicant }: TermsAndConditionProps) {
  const isApproved = status === AccountRequirementStatus.completed;

  return (
    <>
      <Card.Section>
        {isApproved ? (
          <Box childGap="lg" alignItems="center" direction="row" justifyContent="space-between" padding="0 lg 0 0">
            <Box direction="row" alignItems="center">
              <Box padding="0 xs 0 0">
                <StatusIcon status={status} size="md" />
              </Box>
              <Box as="h3" fontWeight="medium" fontSize="md">
                Terms and Conditions
              </Box>
            </Box>
            <Badge message="APPROVED" variant="success" />
          </Box>
        ) : (
          <Box childGap="lg" alignItems="center" direction="row" justifyContent="space-between">
            <Box direction="row" alignItems="center">
              <Box padding="0 xs 0 0">
                <StatusIcon status={status} size="md" />
              </Box>
              <Box as="h3" fontWeight="medium" fontSize="md">
                Terms and Conditions
              </Box>
            </Box>
            <Box fontWeight="medium" fontSize="sm" color="body-secondary">
              Terms and Conditions Not Accepted
            </Box>
            {programType === ProgramType.newHomes && <GetTermsLinkModal primaryApplicant={primaryApplicant} />}
          </Box>
        )}
      </Card.Section>
    </>
  );
}
